export default __webpack_public_path__ + "static/media/pictogramMobile128.a1d1259a.svg";